import {proofKey} from '../artwork-created/artworkCreatedModel.js'
import {safeCommandReturn} from '../workspace/artworkDirectory.js'
export const artworkChampionshipId=value=>/^[1-9][0-9]{0,24}$/.test(String(value||''))?String(value):null
export function championshipArtworkCell(read,championshipId) {
  if(!artworkChampionshipId(championshipId))return {state:'unsupported',rows:[]}
  if(!['ready','conflict'].includes(read?.state))return {state:read?.state==='conflict'?'conflict':read?.state==='error'?'unavailable':'loading',rows:[]}
  if(read.data?.complete!==true)return {state:'unavailable',rows:[]}
  const rows=read.rows||[]
  if(rows.some(row=>String(row.championshipId)!==String(championshipId)))return {state:'unavailable',rows:[]}
  if(!rows.length)return {state:read.state==='conflict'?'conflict':'empty',rows:[]}
  if(read.state==='conflict')return {state:'reconcile',rows}
  if(rows.every(row=>row.deletedAt))return {state:'deleted',rows}
  const saved=rows.filter(row=>!row.deletedAt&&row.artwork?.selected?.proof)
  return {state:saved.length?'saved':'pending',rows,selected:saved[0]||rows[0],historical:saved.some(row=>row.artwork.currentOriginalAvailable===false||row.artwork.selectedVersionScope==='historical')}
}
export function artworkColumnHref({championshipId,jobId,intent='upload',returnTo}) {
  if(!/^[1-9][0-9]{0,24}$/.test(String(championshipId||'')))return null
  const query=new URLSearchParams(jobId?{job:jobId,jobTab:intent==='engine'?'engine':'files'}:{championship:String(championshipId)})
  query.set('tool',intent==='engine'?'engine':'upload')
  const back=safeCommandReturn(returnTo);if(back)query.set('returnTo',back)
  return '/artwork-studio?'+query
}
export function artworkCellVersions(row) {
  const artifacts=[row?.artwork?.selected,...(row?.artwork?.artifacts||[])].filter(artifact=>artifact?.proof)
  return [...new Map(artifacts.map(artifact=>[proofKey(artifact.proof),artifact])).values()]
}
